module.exports = __webpack_public_path__ + "static/images/gift-bg2.907e0e7.png";